<template>
    <div>
        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text ma-1">
                    <v-icon>fas fa-ellipsis-v</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click.prevent="editTransaction(item)" v-if="!item.deleted" >
                    <v-list-item-title>
                        <v-icon small class="mr-2">fas fa-edit</v-icon> Editar {{ item.transactionTypeNatural }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="showEvidencesTransaction(item)">
                    <v-list-item-title>
                        <v-icon small class="mr-2">fas fa-images</v-icon> Imagenes o Evidencias
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="removeTransaction(item)" v-if="!item.deleted || item.registerDateNatural != today">
                    <v-list-item-title class="red--text font-weight-bold">
                        <v-icon small class="mr-2 red--text">fas fa-ban</v-icon> Eliminar {{ item.transactionTypeNatural }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="previewPDF({ isWithPrinter: false})" class="text-primary">
                    <v-list-item-title>
                        <v-icon small class="mr-2">fas fa-file-pdf</v-icon> Imprimir {{ item.transactionTypeNatural }} en PDF
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="previewPDF({ isWithPrinter: true})" class="text-primary">
                    <v-list-item-title class="primary--text font-weight-bold">
                        <v-icon small class="mr-2 primary--text font-weight-bold">fas fa-print</v-icon> Imprimir {{ item.transactionTypeNatural }} en ticket
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <ViewFilesTable :lstFiles="lstEvidences" :dialog="dialogEvidences" title-files="Ficheros y evidencias de transacciones"
        :handleDialogFiles="handleDialogFiles" v-if="dialogEvidences">
        </ViewFilesTable>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob"
            title-pdf="INGRESO/EGREGO" :handlePdfModal="handlePdfModal" :dialog="showPdf" v-if="showPdf">
        </PreviewPDF>
    </div>

</template>
<script>
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import ViewFilesTable from '@/components/shared/ViewFilesTable.vue';
import TransactionFileService from '@/service/transactions/TransactionFileService';
import TransactionRecordService from '@/service/transactions/TransactionRecordService';

export default {
    name: 'ActionTransaction',
    props: {
        item: { type: Object, required: true },
        editTransaction: { type: Function },
        initializeTransaction: { type: Function },
        today: { type: String },
    },
    components: { ViewFilesTable, PreviewPDF },
    data() {
        return {
            openDialogSale: false,
            // to evidences
            lstEvidences: [],
            dialogEvidences: false,
            showPdf: false,
            pdfSource: '',
            pdfBlob: null
        }
    },
    methods: {
        showEvidencesTransaction(item){
            this.dialogEvidences = true;
            this.getEvidencesTransaction(item);
        },
        getEvidencesTransaction({ id: ventaId }) {
            let params = { page: 0, size: 25 };
            this.lstEvidences = [];

            TransactionFileService.table( params, ventaId ).then( response => {
                let evidences = response.data.rows.map(evidence => {
                    return {
                        ...evidence,
                        typeFile: evidence.type.startsWith('image') ? 'image' : 'pdf',
                        url: evidence.name != null ? `${this.$store.state.auth.rutaFichero}transactionEvidences/${evidence.name}` : Camera
                    };
                });
                this.lstEvidences = evidences;
            }).catch(err => {
                this.lstEvidences = [];
                this.$swal.fire({ position: 'top-end', icon: 'error', html: 'Error al cargar las evidencias' + err.response.data, showConfirmButton: false, timer: 3500 });
            })
        },
        handleDialogFiles() { this.dialogEvidences = !this.dialogEvidences; },
        removeTransaction( item ){
            this.$swal.fire({
                title: '¿Estás seguro?',
                text: '¡No podrás revertir esto!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    TransactionRecordService.delete(item.id).then( resp => {
                        this.initializeTransaction();
                        this.$swal.fire({ icon: 'success', title: '¡Hecho!', text: 'Se eliminó correctamente', footer: 'Transacción desactivada', timer: 3500 });
                    }).catch( err => {
                        this.$swal.fire({ icon: 'error', title: 'Oops...', text: 'Algo salió mal!' + err.response.data, footer: 'Intenta de nuevo' });
                    });
                }
            });
        },
        previewPDF({ isWithPrinter = false }) {
            const params = { isWithPrinter }
            TransactionRecordService.printTransaction(this.item.id, params ).then( response => {
                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                this.pdfSource = URL.createObjectURL(this.pdfBlob)
                this.showPdf = true
            }).catch( error => {
                this.$swal.fire({ icon: 'error', html: 'Error al generar el reporte' + error.response.data, showConfirmButton: false, timer: 3500 });
            });
        },
        handlePdfModal(){
            this.showPdf = !this.showPdf
            this.cleanupPdf()
        },
        cleanupPdf(){
            if(this.pdfSource){
                URL.revokeObjectURL(this.pdfSource)
                this.pdfSource = null
            }
            this.pdfBlob = null
        }
    }
}
</script>